// Action enums
export enum ActionTypes {
  GET_APPRAISAL_RULES = "GET_APPRAISAL_RULES",
  GET_TRIZ_PROMPTS = "GET_TRIZ_PROMPTS",
  GET_SCAMPER_PROMPTS = "GET_SCAMPER_PROMPTS",
  GET_LEARNING_PROMPTS = "GET_LEARNING_PROMPTS",
  GET_GUIDANCE = "GET_GUIDANCE",
}
